import { MouseEvent, ReactNode } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

import { ListItem } from '@spotify/confidence-core-react';

import contentStyles from './ArtifactListItem.module.css';

const useStyles = makeStyles({
  root: {
    paddingLeft: 'var(--encore-spacing-tighter-2)',
    '&:hover $action': {
      opacity: 1,
    },
  },
  action: {
    opacity: 0,
    transition: 'opacity 0.15s ease',
    '&:hover, &:focus-within': {
      opacity: 1,
    },
  },
});

const Root = ({
  onClick,
  children,
  className,
}: {
  onClick?: (event: MouseEvent) => void;
  children: ReactNode;
  className?: string;
}) => {
  const classes = useStyles();

  return (
    <ListItem.Root
      className={classNames(classes.root, className)}
      onClick={onClick}
      interactive={!!onClick}
    >
      {children}
    </ListItem.Root>
  );
};

const Icon = ({ children }: { children: ReactNode }) => (
  <ListItem.Icon>{children}</ListItem.Icon>
);

const Content = ({
  primary,
  secondary,
  className,
}: {
  primary?: React.ReactNode;
  secondary?: React.ReactNode;
  className?: string;
}) => (
  <ListItem.Text
    disableText
    primary={<div className={contentStyles.primary}>{primary}</div>}
    secondary={
      secondary && <div className={contentStyles.secondary}>{secondary}</div>
    }
    className={className}
  />
);

const Action = ({ children }: { children: ReactNode }) => {
  const classes = useStyles();

  return (
    <ListItem.Action className={classes.action}>{children}</ListItem.Action>
  );
};

export const ArtifactListItem = {
  Root,
  Icon,
  Content,
  Action,
};
